module.exports = __webpack_public_path__ + "static/media/5860.7d01f50f.jpg";